import React, { Component, ReactPropTypes } from 'react';
import { openNewTab, redirectTo } from '../../../../../helpers/redirect.lib';

class LandingButtonBase extends Component {
    constructor(props) {
        super(props)
    }

    handleClick = () => {
        if(this.props.newTab)
            openNewTab(this.props.redirectURL)
        else
            redirectTo(this.props.redirectURL);
    }

    render() {
        return (
            <button className={`btn dx-landing-button-base ${this.props.buttonClass}`} onClick={this.handleClick}>
                <div className="dx-landing-content-button-base">
                    <div className={`p-2 rounded dx-landing-icon-container-button-base ${this.props.iconClass}`}>
                        <i className="achs-icon">{this.props.icon}</i>
                    </div>
                    <div className="dx-landing-text-container-button-base">
                        <span className={`dx-landing-title-button-base ${this.props.titleClass}`}>{this.props.title}</span>
                        <span className={`dx-landing-description-button-base ${this.props.descriptionClass}`}>{this.props.description}</span>
                    </div>
                </div>
            </button>
        )
    }
}

LandingButtonBase.defaultProps = {
    title: '',
    description: '',
    icon: '',
    buttonClass: '',
    iconClass: '',
    titleClass: '',
    descriptionClass: '',
    redirectURL: '',
    newTab: false
}

export default LandingButtonBase;
